import { Fragment, useEffect, useState } from 'react'
import { history } from 'store/store'
import { SearchBox } from 'modules/mainmenu/styles'
import { ReactComponent as SearchIcon } from 'assets/images/icons/search24.svg'
import { colors, FooterActionButtons, FileInputHidden } from 'modules/app/styles'
import { ResponsesDrawer, ResponseList, FooterButton } from '../responses/styles'
import { Button, DropdownItem, DropdownMenu, DropdownToggle, Label } from 'reactstrap'
import { ReactComponent as InsertIcon } from 'assets/images/icons/insert.svg'
import { connect } from 'react-redux'
import { ButtonLoader, PageLoader } from 'utils/storageUtils'
import { Accordion } from 'react-accessible-accordion'
import Drafts from './components/Drafts'
import Private from './components/Private'
import Pinned from './components/Pinned'
import { PageCategories } from './components/PageCategories'
import { consoleLog, generateSlug, handleApiError, isZoom, logAmplitudeEvent } from 'utils/helpers'
import { createDraft_action, toggleCategoryModal_action, changeTab_action, toggleSettingsModal_action, toggleTemplatesModal_action, toggleTemplatesSidebar_action } from 'store/actions'
import { EmptyResultComponent } from '../EmptyResultComponent'
import { getContents_api, getDrafts_api } from 'store/apis'
import { useCallback } from 'react'
import { uniq } from 'lodash'

let searchTimeout = null
export const PagesTab = (props) => {
  const { createDraft, drafts, pages } = props
  const { uncategorized_private_contents, private_categories, shared_categories, favorites } = pages
  const [is_importing, set_is_importing] = useState(false)
  const [preExpanded, set_preExpanded] = useState([])
  const [searchText, set_searchText] = useState('')
  const [isSearching, set_isSearching] = useState(false)

  const [my_drafts_list, set_my_drafts_list] = useState([])
  const [shared_drafts_list, set_shared_drafts_list] = useState([])
  const [state_shared_categories, set_state_shared_categories] = useState([])
  const [state_uncategorized_private_contents, set_state_uncategorized_private_contents] = useState([])
  const [state_private_categories, set_state_private_categories] = useState([])
  const [state_favorites, set_state_favorites] = useState([])
  useEffect(() => set_state_uncategorized_private_contents(uncategorized_private_contents), [uncategorized_private_contents])
  useEffect(() => set_state_shared_categories(shared_categories), [shared_categories])
  useEffect(() => set_state_private_categories(private_categories), [private_categories])
  useEffect(() => set_state_favorites(favorites), [favorites])
  // Create Draft List
  useEffect(() => {
    set_my_drafts_list(JSON.parse(JSON.stringify(drafts.my_drafts)))
    set_shared_drafts_list(JSON.parse(JSON.stringify(drafts.shared_drafts)))
  }, [drafts])

  // Import Document
  const uploadDocument = async (name, htmlString) => {
    try {
      set_is_importing(true)
      const data = {
        title: name,
        content: htmlString
      }
      const draft = await createDraft(data)
      history.push(`/pages/drafts/edit/${generateSlug(draft)}`)
    } catch (error) {}
    set_is_importing(false)
  }
  const onUploadFile = async (e) => {
    const file = e.target.files[0]
    const allowedExtensions = ['html', 'doc', 'docx', 'md']
    if (file) {
      try {
        const fullFilename = file.name.split('.')
        const fileExtension = fullFilename.pop()
        const filename = fullFilename.join('.')
        if (allowedExtensions.includes(fileExtension)) {
          let resultHtml = ''
          if (fileExtension === 'docx') {
            const reader = new FileReader()
            reader.onload = async function () {
              const mammoth = require('mammoth')
              const result = await mammoth.convertToHtml({ arrayBuffer: this.result })
              resultHtml = result.value
              uploadDocument(filename, resultHtml)
            }
            reader.readAsArrayBuffer(file)
          } else if (fileExtension === 'md') {
            const reader = new FileReader()
            reader.onload = async function () {
              const showdown = require('showdown')
              const converter = new showdown.Converter()
              resultHtml = converter.makeHtml(this.result)
              uploadDocument(filename, resultHtml)
            }
            reader.readAsText(file)
          } else if (fileExtension === 'html') {
            const reader = new FileReader()
            reader.onload = async function () {
              resultHtml = this.result
              uploadDocument(filename, resultHtml)
            }
            reader.readAsText(file)
          }
        } else {
          alert('Only file with html, doc, docx and md extension is allowed.')
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }

  const searchData = useCallback(
    async (search) => {
      if (search?.trim()) {
        try {
          const _preExpanded = []
          set_isSearching(true)
          const _drafts = await getDrafts_api({ search: encodeURIComponent(search) })
          const contents = await getContents_api({ search: encodeURIComponent(search), type: 'page' })

          // Drafts
          const _my_drafts_list = JSON.parse(JSON.stringify(_drafts.my_drafts))
          const _my_shared_drafts_list = JSON.parse(JSON.stringify(_drafts.shared_drafts))
          set_my_drafts_list(_my_drafts_list)
          set_shared_drafts_list(_my_shared_drafts_list)
          if (_my_shared_drafts_list.length > 0) {
            _preExpanded.push('shared_drafts')
          }
          if (_my_drafts_list.length > 0) {
            _preExpanded.push('my_drafts')
          }

          // Published
          const _uncategorized_private_contents = contents.filter((item) => !item.category_id)
          set_state_uncategorized_private_contents(_uncategorized_private_contents)
          if (_uncategorized_private_contents.length) {
            _preExpanded.push('private')
          }

          const categorized_contents = contents.filter((item) => item.category_id)
          let rootCategories = []
          for (const content of categorized_contents) {
            if (content.category?.parent_category?.parent_category) {
              const i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.parent_category?.id)
              if (i === -1) {
                rootCategories.push({
                  ...content.category?.parent_category?.parent_category,
                  contents: [],
                  subcategories: []
                })
              }
            } else if (content.category?.parent_category) {
              const i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
              if (i === -1) {
                rootCategories.push({
                  ...content.category?.parent_category,
                  contents: [],
                  subcategories: []
                })
              }
            } else if (content.category) {
              const i = rootCategories.findIndex((cat) => cat.id === content.category?.id)
              if (i === -1) {
                rootCategories.push({
                  ...content.category,
                  contents: [],
                  subcategories: []
                })
              }
            }

            // Check content.category is a root category
            const i = rootCategories.findIndex((cat) => cat.id === content.category?.id)
            if (i !== -1) {
              rootCategories[i].contents.push(content)
              _preExpanded.push(`cat_${content.category?.uuid}`)
            } else {
              // If NOT content.category is a root category
              // Check if content.category.parent_category is a root category
              const root_i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
              if (root_i !== -1) {
                // If root category found, then find the subcategory for content.category.parent_category
                const sub_cat_i = rootCategories[root_i].subcategories.findIndex((cat) => cat.id === content.category?.id)
                if (sub_cat_i !== -1) {
                  rootCategories[root_i].subcategories[sub_cat_i].contents.push(content)
                  _preExpanded.push(`cat_${rootCategories[root_i]?.uuid}`)
                  _preExpanded.push(`cat_${rootCategories[root_i]?.subcategories[sub_cat_i]?.uuid}`)
                } else {
                  rootCategories[root_i].subcategories.push({
                    ...content.category,
                    subcategories: [],
                    contents: [content]
                  })
                  _preExpanded.push(`cat_${content.category?.uuid}`)
                }
                _preExpanded.push(`cat_${rootCategories[root_i].uuid}`)
              } else {
                // If NOT content.category.parent_category is a root category
                // Check if content.category.parent_category.parent_category is a root category
                const root_i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.parent_category?.id)
                if (root_i !== -1) {
                  // if root category, then find the subcategory of content.category?.parent_category?.id
                  const sub_cat_i = rootCategories[root_i].subcategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
                  // If found the subcategory, then find the sub_subcategory of content.category.id
                  if (sub_cat_i !== -1) {
                    const sub_sub_cat_i = rootCategories[root_i].subcategories[sub_cat_i].subcategories.findIndex((cat) => cat.id === content.category?.id)
                    // If found the sub sub category, then push the contents into sub sub category
                    if (sub_sub_cat_i !== -1) {
                      rootCategories[root_i].subcategories[sub_cat_i].subcategories[sub_sub_cat_i].contents.push(content)
                    } else {
                      rootCategories[root_i].subcategories[sub_cat_i].subcategories.push({
                        ...content.category,
                        contents: [content],
                        subcategories: []
                      })
                    }
                    _preExpanded.push(`cat_${content.category?.uuid}`)
                  } else {
                    // If not found the sub sub category, push in sub category
                    rootCategories[root_i].subcategories.push({
                      ...content.category?.parent_category,
                      contents: [],
                      subcategories: [
                        {
                          ...content.category,
                          contents: [content],
                          subcategories: []
                        }
                      ]
                    })
                    _preExpanded.push(`cat_${content.category?.parent_category?.uuid}`)
                    _preExpanded.push(`cat_${content.category?.uuid}`)
                  }
                  _preExpanded.push(`cat_${rootCategories[root_i].uuid}`)
                }
              }
            }
          }
          const _shared_categories = rootCategories.filter((cat) => cat.shared_users.length)
          const _private_categories = rootCategories.filter((cat) => !cat.shared_users.length)

          set_state_favorites([])
          set_state_private_categories(_private_categories)
          set_state_shared_categories(_shared_categories)
          set_preExpanded(uniq(_preExpanded))
        } catch (error) {
          consoleLog(error)
        }
        set_isSearching(false)
      } else {
        set_preExpanded([])
        set_my_drafts_list(JSON.parse(JSON.stringify(drafts.my_drafts)))
        set_shared_drafts_list(JSON.parse(JSON.stringify(drafts.shared_drafts)))
        set_state_uncategorized_private_contents(uncategorized_private_contents)
        set_state_shared_categories(shared_categories)
        set_state_private_categories(private_categories)
        set_state_favorites(favorites)
      }
    },
    [drafts, uncategorized_private_contents, private_categories, shared_categories, favorites]
  )

  useEffect(() => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => searchData(searchText), 500)
  }, [searchText, searchData])
  return (
    <Fragment>
      <FileInputHidden type='file' name='uploadDocMenu' id='uploadDocMenu' accept='.md,.doc,.docx,.html' onChange={onUploadFile} />

      <SearchBox>
        <SearchIcon stroke={colors['text-secondary']} className='searchIcon' />
        <input type='text' className='SearchInput' placeholder='Search your Pages' onChange={(e) => set_searchText(e.target.value)} value={searchText} />
      </SearchBox>

      <ResponsesDrawer>
        <ResponseList id='pageScrollDiv'>
          {isSearching && (
            <div className='d-flex justify-content-center'>
              <div>
                <PageLoader />
                Searching for <b>{searchText}...</b>
              </div>
            </div>
          )}
          {!isSearching &&
            searchText &&
            my_drafts_list.length + shared_drafts_list.length + state_uncategorized_private_contents.length + state_private_categories.length + state_shared_categories.length === 0 && (
              <EmptyResultComponent />
            )}
          {!isSearching && my_drafts_list.length + shared_drafts_list.length + state_uncategorized_private_contents.length + state_private_categories.length + state_shared_categories.length > 0 && (
            <Accordion allowMultipleExpanded allowZeroExpanded preExpanded={preExpanded} key={preExpanded.length}>
              {/* Pinned */}
              {state_favorites.length > 0 && (
                <div className='py-3'>
                  <h5 className='mb-0 mx-3'>{/* <small className='section-name text-muted font-weight-600'>Pinned</small> */}</h5>
                  <Pinned favorites={state_favorites} />
                </div>
              )}

              {/* Drafts */}
              {shared_drafts_list.length + my_drafts_list.length > 0 && (
                <div className='py-3'>
                  <h5 className='mb-0 mx-3'>
                    <small className='section-name text-muted font-weight-600'>DRAFTS</small>
                  </h5>
                  <Drafts searchText={searchText} preExpanded={preExpanded} shared_drafts_list={shared_drafts_list} my_drafts_list={my_drafts_list} />
                </div>
              )}

              {state_uncategorized_private_contents.length + state_private_categories.length > 0 && (
                <div className='py-3'>
                  <h5 className='mb-0 mx-3'>
                    <small className='section-name text-muted font-weight-600'> Private</small>
                  </h5>
                  {state_uncategorized_private_contents.length > 0 && <Private searchText={searchText} state_uncategorized_private_contents={state_uncategorized_private_contents} />}
                  {state_private_categories.length > 0 && <PageCategories isPrivate={true} section='private' searchText={searchText} preExpanded={preExpanded} categories={state_private_categories} />}
                </div>
              )}

              {state_shared_categories.length > 0 && (
                <div className='py-3'>
                  <h5 className='mb-0 mx-3'>
                    <small className='section-name text-muted font-weight-600'> Shared</small>
                  </h5>
                  <PageCategories isPrivate={false} section='shared' searchText={searchText} preExpanded={preExpanded} categories={state_shared_categories} />
                </div>
              )}
            </Accordion>
          )}
        </ResponseList>
        <FooterButton>
          <FooterActionButtons>
            <Button
              onClick={() => {
                  if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                    props.toggleSettingsModal(true)
                    props.changeTab('billing')
                    history.push('/')
                  } else {
                    history.push('/pages/drafts/create')
                    logAmplitudeEvent('Creating new draft')
                  }
                }}
              disabled={is_importing}>
              <InsertIcon fill={colors['main-blue']} /> New Page {is_importing && <ButtonLoader />}
            </Button>
            <DropdownToggle split disabled={is_importing} />
            <DropdownMenu right>
              <DropdownItem onClick={() => props.toggleCategoryModal(true, { type: 'page' })} className='dropdown-button'>
                New Category
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                    props.toggleSettingsModal(true)
                    props.changeTab('billing')
                    history.push('/')
                  } else {
                    history.push('/pages/drafts/create')
                    props.toggleTemplatesSidebar(true)
                    props.toggleTemplatesModal(true)
                    logAmplitudeEvent('Started a page with a template from side menu')
                  }
                }}
                className='dropdown-button'>
                New From Template
              </DropdownItem>
              {!isZoom() && (
                <DropdownItem tag='div' className='dropdown-button import'>
                  <Label htmlFor='uploadDocMenu' className='mb-0 w-100' onClick={(e) => e.stopPropagation()}>
                    Import
                  </Label>
                </DropdownItem>
              )}
            </DropdownMenu>
          </FooterActionButtons>
        </FooterButton>
      </ResponsesDrawer>
    </Fragment>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  drafts: state.contents.drafts,
  pages: state.contents.pages,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  is_subscribed: state.subscription.is_subscribed,
  free_items_limit: state.company.company.free_items_limit,
  total_items_count: state.app.total_items_count
})

const mapDispatchToProps = (dispatch) => ({
  toggleTemplatesModal: (value) => dispatch(toggleTemplatesModal_action(value)),
  toggleTemplatesSidebar: (value) => dispatch(toggleTemplatesSidebar_action(value)),
  toggleCategoryModal: (status, item) => dispatch(toggleCategoryModal_action(status, item)),
  createDraft: (data) => new Promise((resolve, reject) => dispatch(createDraft_action(data, resolve, reject))),
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  changeTab: (value) => dispatch(changeTab_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(PagesTab)
